import React from 'react'

import { Body } from './styles'

const MarkdownBody = ({ body, as }) => (
  <Body as={as} dangerouslySetInnerHTML={{ __html: body.childMarkdownRemark.html }} />
)

export default MarkdownBody
